import React from "react";
import Footer from "../../../../containers/Footer";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";

import Offerbanner from "../../../../assets/images/banner/offersbanner.jpg"

const Offers = () => {
    return (
        <>
            <HeaderAfterLogin />
            <div className="container-fluid">
                <main className="main">
                    <div className="OffersSection">
                        <div className="OfferBanner">
                            <img src={Offerbanner} alt="Offerbanner" />
                        </div>

                        <div className="Offercontent">
                            <p>Have Funn by playing at Funn777 events ..in coming days we will come with live events ..stay tuned for more Excitement..
                            </p>
                            <ul>
                                <li>Weekly jackpot 35 to 50 deposits . 300% cash bonus upto 1lakh</li>
                                <li>⁠Monthly Deposits - we will pick up lucky winner who has deposits more than 130 Times . <span>Will be eligible for iPhone 16</span></li>
                                <li>We will pickup any random customers and offer of 20percent for a single day ..on that day any number of deposits will have 20% Bonus</li>
                                <li>⁠Customer loyalty program- we will pickup 3 lucky customers in any of the month and will give them loyalty rewards of 2500/- , 1500, 500/- <span>Customers will be chosen on lucky draw basis</span></li>
                                <li>Lucky Looser- we will choose any customers who lost more than 25k in a week will be given ..2500/- cashback and will be chosen on lucky draw basis ….</li>
                            </ul>
                            <p>
                                <span>Note -</span> any rewards given cannot be withdrawn .customers have to complete 1.5x rolling for eligibility..
                            </p>
                            <p><span>Note - </span>Sports customers will not be eligible for Offers and Jackpots</p>
                            <p><span>Note -</span>Winner will be called from our agents and direct rewards will be provided …</p>
                            <p>Terms and conditions apply ..For Terms and conditions please contact customer support or your agents …</p>
                        </div>
                    </div>
                </main>
            </div>
            <Footer />
        </>
  );
}

export default Offers;